export enum PixSMSModalState {
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
  EXPIRED = 'expired',
}

export type IPixSMSConfirmationModalProps = {
  open: boolean;
  setOpenModal: Function;
  setOpenQRCodePix?: () => void; 
};
